<mat-icon class="info-icon" (click)="openSumTreeInfoDialog()">info</mat-icon>

  <div class="shape-legend">
    <div class="row">
      <div class="circle1">1</div>
      <div class="legend-shape-text">1 Concept</div>
    </div>
    <div class="row">
      <div class="number-symbol">N</div>
      <div class="rectangle"></div>
      <div class="legend-shape-text">N Concepts</div>
    </div>
  </div>

  <mat-slide-toggle *ngIf="false" 
    (change)="onLayoutToggle()" 
    [checked]="true"
    [disabled]="true">
    Compact Layout
  </mat-slide-toggle>

  <mat-form-field class="form-field">
    <mat-select placeholder="Counts" [value]="summaryType" (selectionChange)="summaryType=$event.value">
      <mat-option *ngFor="let type of summaryTypes" [value]="type.value">
        {{ type.viewValue }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-select placeholder="Color" [(value)]="colorField" (selectionChange)="colorField=$event.value" #colorSelector>
      <mat-option *ngFor="let type of colorFields" [value]="type.value">
        {{ type.viewValue }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-chip-list class="mat-chip-list-stacked">
    <mat-chip *ngFor="let chip of colorMappings[colorSelector.selected?.value]" selected="true" [style.background]="chip.color">
      {{chip.label}}
    </mat-chip>
  </mat-chip-list>

  <mat-form-field class="form-field">
    <mat-select placeholder="Opacity" [(value)]="opacityField" (selectionChange)="opacityField" #opacitySelector>
      <mat-option *ngFor="let type of opacityFields" [value]="type.value">
        {{ type.viewValue }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-chip-list class="mat-chip-list-stacked">
    <mat-chip *ngFor="let chip of opacityMappings[opacitySelector.selected?.value]" selected="true" [style.background]="chip.color">
      {{chip.label}}
    </mat-chip>
  </mat-chip-list>


// WEBPACK FOOTER //
// ./src/app/hsd-ui/legend/legend.component.html